import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { MoveShowDocument } from './move.generated';

export const useMoveShow = (options: ApiOptions<typeof MoveShowDocument> = {}) => {
  const { t } = useTranslation();

  return useMutation(MoveShowDocument, {
    ...useNotifications(MoveShowDocument, {
      failure: t('api.common.error_generic'),
      success: t('api.shows.move_success'),
    }),
    ...options,
  });
};
